import styled from 'styled-components';
import Tabs from '../sharedComponents/Tabs';

export const CALENDAR_DISPLAY_MODES = {
  IMPLEMENTATIONS: 'Implementations',
  EVENTS: 'Events'
};

const tabs = [
  CALENDAR_DISPLAY_MODES.IMPLEMENTATIONS,
  CALENDAR_DISPLAY_MODES.EVENTS
];

const ModeSection = styled.div`
  width: 100%;
  padding-bottom: 10px;
  border-bottom: solid 1px #d9dee5;
`

const Label = styled.div`
  margin-bottom: 4px;
  color: #4b5563;
  font-size: 12px;
  font-weight: 700;
`

export default function ImplementationCalendarModeFilter({
  selectedMode,
  onChange
}) {
  return (
    <ModeSection>
      <Label>Display</Label>
      <Tabs
        tabs={tabs}
        selectedTab={selectedMode}
        setSelectedTab={onChange}
        suppressBorderBottom={true}
        containerStyle={{ paddingLeft: 0 }}
      />
    </ModeSection>
  );
}
